// extracted by mini-css-extract-plugin
export default {"edit":"Header_edit__xgRQq","cancel":"Header_cancel__U4kyY"};